import { render } from "./DropDownSelect.vue?vue&type=template&id=5f155f30&scoped=true&ts=true"
import script from "./DropDownSelect.vue?vue&type=script&lang=ts"
export * from "./DropDownSelect.vue?vue&type=script&lang=ts"

import _style_0 from "./DropDownSelect.vue?vue&type=style&index=0&id=5f155f30&inline&scoped=true&lang=css"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-5f155f30"]])

export default __exports__